import { magic } from '@gig/magic-sdk';
import VueRouter from 'vue-router';
import { RouteName } from '../../../routes/routes.constants';
import { isBankIdAccountLinkingEnabled } from '../../../util';
import { isRouteActive } from '../helpers/routes';

export function initAccountLinkingGuard(router: VueRouter) {
    router.beforeEach(async (to, _, next) => {
        if (isRouteActive(RouteName.ACCOUNT_LINKING, to, router)) {
            if (!(await isBankIdAccountLinkingEnabled())) {
                return next({
                    name: RouteName.HOME,
                });
            }

            const profileV2Promise: ReturnType<
                typeof magic.methods.users.getProfileV2
            > = magic.invokeCached(60, magic.methods.users, 'getProfileV2')();

            const profile = await profileV2Promise;

            if (profile.personId) {
                return next({
                    name: RouteName.HOME,
                });
            }
        }

        next();
    });
}
